module.exports = __webpack_public_path__ + "img/bd2ce12c505fefc266fa52968f9ad578.jpg";